module.exports = __webpack_public_path__ + "static/seo-dokka-b757589519acdfa20724e984ed8b8960.png";